import { type UseQueryResult, useQuery } from 'react-query';
import {
  DashboardService,
  // eslint-disable-next-line camelcase
  type Wealthlane_CustomerService_Dtos_Dashboard_AdminDashboardResponseDto,
} from '../../services/wealthlane-customer-services';

const useGetCustomerCustomerDashboardDetails = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Wealthlane_CustomerService_Dtos_Dashboard_AdminDashboardResponseDto | undefined,
  unknown
> => {
  const customerCustomerDashboardDetails = useQuery(
    ['getCustomerCustomerDashboardDetails'],
    async () => {
      return await handleRequest(DashboardService.getApiCustomerApiAppDashboardAdminDashboard());
    }
  );

  return customerCustomerDashboardDetails;
};

export default useGetCustomerCustomerDashboardDetails;
